import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/4182617cdf157d9c4d6ecd089b30333d.jpg',
      title: 'Kalite Yönetim Sistemleri'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=TURKAK%20accredited%20calibration%20laboratory%20technician%20performing%20precision%20measurement%20on%20industrial%20equipment%2C%20real%20professional%20metrology%20workspace%20with%20calibration%20instruments%20and%20certificates%2C%20authentic%20technical%20photography%20showing%20measurement%20accuracy%20verification%2C%20clean%20professional%20environment&width=1200&height=700&seq=kgm-slide-2&orientation=landscape',
      title: 'TÜRKAK Akrediteli Kalibrasyon'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=export%20documentation%20and%20international%20shipping%20containers%20at%20port%2C%20real%20business%20professionals%20reviewing%20CE%20mark%20and%20export%20certificates%2C%20authentic%20international%20trade%20photography%20showing%20global%20commerce%2C%20professional%20corporate%20setting%20with%20shipping%20logistics&width=1200&height=700&seq=kgm-slide-3&orientation=landscape',
      title: 'İhracat Belgelendirme'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=software%20developers%20working%20on%20industrial%20management%20system%20dashboard%2C%20real%20programmers%20coding%20quality%20control%20software%20on%20multiple%20monitors%2C%20authentic%20tech%20workspace%20showing%20digital%20transformation%2C%20modern%20office%20with%20professional%20development%20team&width=1200&height=700&seq=kgm-slide-4&orientation=landscape',
      title: 'Dijital Çözümler'
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      {/* Sticky Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="#" className="flex items-center cursor-pointer">
              <img
                src="https://static.readdy.ai/image/2b1409af55cbbc24ae624602859a344f/49982b335b96708abcb5cab4610886b0.png"
                alt="KGM Danışmanlık"
                className="h-16"
              />
            </a>

            <div className="hidden md:flex items-center gap-10">
              <a href="#hizmetler" className={`text-sm font-semibold transition-colors cursor-pointer ${scrolled ? 'text-[#2D3436] hover:text-[#C17F59]' : 'text-white hover:text-[#C17F59]'}`}>
                Hizmetler
              </a>
              <a href="#hakkimizda" className={`text-sm font-semibold transition-colors cursor-pointer ${scrolled ? 'text-[#2D3436] hover:text-[#C17F59]' : 'text-white hover:text-[#C17F59]'}`}>
                Hakkımızda
              </a>
              <Link to="/blog" className={`text-sm font-semibold transition-colors cursor-pointer ${scrolled ? 'text-[#2D3436] hover:text-[#C17F59]' : 'text-white hover:text-[#C17F59]'}`}>
                Blog
              </Link>
              <a href="#neden-biz" className={`text-sm font-semibold transition-colors cursor-pointer ${scrolled ? 'text-[#2D3436] hover:text-[#C17F59]' : 'text-white hover:text-[#C17F59]'}`}>
                Neden Biz
              </a>
              <a href="#iletisim" className={`text-sm font-semibold transition-colors cursor-pointer ${scrolled ? 'text-[#2D3436] hover:text-[#C17F59]' : 'text-white hover:text-[#C17F59]'}`}>
                İletişim
              </a>
              <a href="tel:+905543791632" className="bg-[#C17F59] text-white px-7 py-3 rounded-lg text-sm font-semibold hover:bg-[#A66B47] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer">
                Hemen Arayın
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button className="md:hidden text-white">
              <i className={`ri-menu-line text-2xl ${scrolled ? 'text-[#2D3436]' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden bg-[#2D3436]">
        {/* Industrial Background */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20industrial%20factory%20floor%20with%20architectural%20blueprint%20overlay%20and%20digital%20interface%20elements%2C%20high-tech%20manufacturing%20facility%20with%20precision%20engineering%20equipment%2C%20professional%20corporate%20atmosphere%20showing%20quality%20control%20systems%20and%20automation%20technology%2C%20dark%20charcoal%20grey%20tones%20with%20copper%20orange%20accent%20lighting%2C%20contemporary%20industrial%20design%20with%20depth%20and%20sophistication&width=1920&height=1080&seq=kgm-hero-industrial-bg&orientation=landscape"
            alt="KGM Industrial Solutions"
            className="w-full h-full object-cover object-center opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#2D3436]/95 via-[#2D3436]/90 to-[#2D3436]/95"></div>
        </div>

        {/* Geometric Decorative Elements */}
        <div className="absolute top-20 right-10 w-64 h-64 border border-[#C17F59]/20 rounded-full opacity-20"></div>
        <div className="absolute bottom-20 left-10 w-48 h-48 border border-[#C17F59]/20 rounded-full opacity-20"></div>

        {/* Content */}
        <div className="relative max-w-7xl mx-auto px-6 py-32 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left Content */}
            <div>
              <div className="inline-flex items-center bg-[#C17F59]/10 backdrop-blur-sm border border-[#C17F59]/30 px-5 py-2.5 rounded-lg mb-8">
                <i className="ri-global-line text-[#C17F59] mr-2"></i>
                <span className="text-[#C17F59] text-sm font-semibold">Endüstriyel Çözüm Merkezi • Global Vizyon</span>
              </div>

              <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-[1.1] tracking-tight">
                Sanayi, İhracat ve Kalite Süreçlerinin<br />
                <span className="text-[#C17F59]">Tek Çözüm Ortağı</span>
              </h1>

              <p className="text-xl text-gray-300 mb-6 leading-relaxed">
                Fabrika kurulumundan ihracat belgelerine (CE, EAC, SABER), devlet teşviklerinden dijital dönüşüm yazılımlarına kadar işletmenizin tüm ihtiyaçları tek çatı altında.
              </p>

              <p className="text-base text-gray-400 mb-10 leading-relaxed">
                Yatırım fikrinden ihracat aşamasına, mevzuat danışmanlığından yazılım çözümlerine kadar 360° hizmet anlayışıyla yanınızdayız.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#hizmetler"
                  className="inline-flex items-center justify-center bg-[#C17F59] text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-[#A66B47] transition-all hover:shadow-[0_8px_30px_rgba(193,127,89,0.4)] hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <span>Hizmetlerimiz</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <a
                  href="tel:+905543791632"
                  className="inline-flex items-center justify-center bg-transparent text-white border-2 border-white/30 px-8 py-4 rounded-lg text-base font-bold hover:bg-white/10 hover:border-white/50 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Hemen Arayın
                </a>
              </div>
            </div>

            {/* Right Visual - Removed */}
            <div className="hidden lg:block"></div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
          <a href="#slider-section" className="flex flex-col items-center gap-2 cursor-pointer">
            <span className="text-white/70 text-xs uppercase tracking-wider font-semibold">Keşfet</span>
            <i className="ri-arrow-down-line text-white text-2xl"></i>
          </a>
        </div>
      </section>

      {/* Image Slider Section */}
      <section id="slider-section" className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#2D3436] mb-4">
              Hizmetlerimizden Görüntüler
            </h2>
            <p className="text-lg text-gray-600">
              Profesyonel ekibimiz ve modern tesislerimizle yanınızdayız
            </p>
          </div>

          <div className="relative">
            {/* Slider Container */}
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-1000 ${
                    index === currentSlide ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-8 left-8 right-8">
                    <h3 className="text-3xl font-bold text-white mb-2">{slide.title}</h3>
                  </div>
                </div>
              ))}

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center text-white hover:bg-white/30 transition-all cursor-pointer"
                aria-label="Önceki"
              >
                <i className="ri-arrow-left-line text-2xl"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center text-white hover:bg-white/30 transition-all cursor-pointer"
                aria-label="Sonraki"
              >
                <i className="ri-arrow-right-line text-2xl"></i>
              </button>

              {/* Dots Indicator */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      index === currentSlide
                        ? 'bg-[#C17F59] w-8'
                        : 'bg-white/50 hover:bg-white/80'
                    }`}
                    aria-label={`Slayt ${index + 1}`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Strip - Global & Local Compliance */}
      <section id="trust-strip" className="py-12 bg-white border-y border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <p className="text-center text-sm font-semibold text-gray-600 mb-8 uppercase tracking-wider">
            Güvenle Hizmet Verdiğimiz Standartlar ve Akreditasyonlar
          </p>
          <div className="flex flex-wrap items-center justify-center gap-12">
            <div className="grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=TURKAK%20Turkish%20Accreditation%20Agency%20official%20logo%2C%20professional%20certification%20badge%2C%20simple%20clean%20design%20on%20white%20background&width=120&height=80&seq=turkak-logo&orientation=landscape" alt="TÜRKAK" className="h-12 object-contain" />
            </div>
            <div className="grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=TSE%20Turkish%20Standards%20Institution%20official%20logo%20badge%2C%20professional%20certification%20symbol%2C%20clean%20design&width=120&height=80&seq=tse-logo&orientation=landscape" alt="TSE" className="h-12 object-contain" />
            </div>
            <div className="grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=CE%20Mark%20European%20Conformity%20certification%20logo%2C%20official%20standard%20symbol%2C%20professional%20design&width=120&height=80&seq=ce-logo&orientation=landscape" alt="CE Mark" className="h-12 object-contain" />
            </div>
            <div className="grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=EAC%20Eurasian%20Conformity%20certification%20mark%20logo%2C%20official%20standard%20badge%2C%20clean%20professional%20design&width=120&height=80&seq=eac-logo&orientation=landscape" alt="EAC" className="h-12 object-contain" />
            </div>
            <div className="grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=SABER%20Saudi%20Arabia%20certification%20logo%20SASO%20conformity%20badge%2C%20official%20standard%20symbol%2C%20professional%20design&width=120&height=80&seq=saber-logo&orientation=landscape" alt="SABER" className="h-12 object-contain" />
            </div>
            <div className="grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 cursor-pointer">
              <img src="https://readdy.ai/api/search-image?query=Turkey%20Ministry%20of%20Industry%20official%20logo%20badge%2C%20government%20certification%20symbol%2C%20professional%20design&width=120&height=80&seq=ministry-logo&orientation=landscape" alt="TC Sanayi Bakanlığı" className="h-12 object-contain" />
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/905543791632?text=Merhaba,%20hizmetleriniz%20hakkında%20bilgi%20almak%20istiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-[#C17F59] text-white w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all z-[9999] cursor-pointer hover:shadow-[0_8px_30px_rgba(193,127,89,0.6)]"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`fixed bottom-28 right-6 bg-[#2D3436] text-white w-12 h-12 rounded-lg flex items-center justify-center shadow-lg hover:bg-[#C17F59] transition-all z-[9998] ${scrolled ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        aria-label="Yukarı çık"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </>
  );
}
